import { Button } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../AppContext';

// "← Track another order" — the affordance the prod page (old Layout.js) had, now available to
// EVERY template. Clears the loaded order and returns to the search page. Hidden in the panel
// preview (`preview` prop): the iframe shows a sample order and has no meaningful "/" to go to.
export default function TrackAnotherButton({ preview, sx }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setValues } = useAppContext();

    if (preview) {
        return null;
    }

    const handleTrackAnother = () => {
        setValues(null);
        navigate('/');
    };

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={handleTrackAnother}
            sx={{
                borderColor: 'rgba(0,0,0,0.12)',
                color: 'text.secondary',
                '&:hover': {
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    bgcolor: alpha(theme.palette.primary.main, 0.04),
                },
                ...sx,
            }}
        >
            &larr; Track another order
        </Button>
    );
}
